export default __webpack_public_path__ + "static/media/arcgis-business-analyst.25b4cf85.svg";